// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"9870488a","189":"0dda8e8b","267":"e0510357","392":"fcb18b25","478":"d0b0dbd4","506":"83814c7d","598":"607f3e7b","666":"a7af7521","687":"b5c24e71"}[chunkId] + ".chunk.js";
};